import { lazy } from 'react';

export const HomePage = lazy(() => import("./Home/index.page"));
export const UserLogin = lazy(() => import("./UserLogin/index.page"));
export const CreateAccount = lazy(() => import("./CreateAccount/index.page"));
export const UserForgot = lazy(() => import("./UserForgot/index.page"));
export const UserVerification = lazy(() => import("./UserVerification/index.page"));
export const ResetPassword = lazy(() => import("./ResetPassword/index.page"));
export const UpcomingTrip = lazy(() => import("./UpcomingTrip/index.page"));
export const Search = lazy(() => import("./Search/index.page"));
export const TripDetails = lazy(() => import("./TripDetails/index.page"));
export const TourGuide = lazy(() => import("./TourGuide/index.page"));
export const Review = lazy(() => import("./Review/index.page"));
export const DaysPlan = lazy(() => import("./DaysPlan/index.page"));
export const Notification = lazy(() => import("./Notification/index.page"));
export const Checkout = lazy(() => import("./Checkout/index.page"));
export const UsersProfile = lazy(() => import("./UsersProfile/index.page"));
export const UsersProfileEdit = lazy(() => import("./UsersProfileEdit/index.page"));
export const ChangePassword = lazy(() => import("./ChangePassword/index.page"));
export const BookingHistory = lazy(() => import("./BookingHistory/index.page"));
export const BookingHistoryDetails = lazy(() => import("./BookingHistoryDetails/index.page"));
export const AddReview = lazy(() => import("./AddReview/index.page"));
export const HelpSupport = lazy(() => import("./HelpSupport/index.page"));
export const UserFaq = lazy(() => import("./UserFaq/index.page"));
export const UserAbout = lazy(() => import("./UserAbout/index.page"));
export const Welcome = lazy(() => import("./Welcome/index.page"));
export const UserCMS = lazy(() => import("./UserCMS/index.page"));


